{
  "permissions": {
    "noPermission": "You don't have permission to perform this action",
    "viewOnly": "View only"
  },
  "importFinished": "Import has finished",
  "switchLevel": "Switch level",
  "removeFilter": "Remove filter",
  "styleByProperty": "Set model dimensions using list item property values",
  "styleByPropertyTooltip": "When enabled, the size of models in this layer will be determined using dimensions from your list item table. Your list items must contain additional, numeric columns for 'Width', 'Length', and 'Height' to use this option. For detailed instructions, refer to our",
  "styleByPropertyTooltipLink": "knowledge base article",
  "copy": {
    "copyTo": "Copy to this location",
    "setTo": "Set new location",
    "tooltip": {
      "Map": "Cannot copy into a plan",
      "Layer": "Cannot copy into a layer"
    }
  },
  "digitalTwin": {
    "cameraModes": {
      "orbit": "Orbit Camera",
      "walk": "Walk Through",
      "fly": "Fly Camera"
    }
  },
  "venue_bookmark": "Venue bookmark",
  "venue_bookmark_form": {
    "save": "Save bookmark",
    "name": "Name"
  },
  "venue_bookmark_view": {
    "bookmarks": "Bookmarks",
    "delete_bookmark": "Delete bookmark",
    "create_bookmark": "Create bookmark from current view",
    "no_bookmarks": "No bookmarks"
  },
  "venue_bookmark_no_venue_error": {
    "title": "Unable to create bookmark",
    "message": "You cannot create a bookmark away from a Venue"
  },
  "venue_bookmark_creation_error": {
    "title": "Unable to create bookmark",
    "message": "There was an error creating the bookmark. Please try again later."
  },
  "controls": {
    "toggle_street_names": "Street and place names",
    "disabled_terrain_sitemap_3d": "Terrain cannot be turned on when a 3D sitemap is in view",
    "disabled_3d_buildings_sitemap_3d": "3D buildings cannot be turned on when a 3D sitemap is in view"
  },
  "modelPreview": {
    "front_view": "Front view",
    "front_left_view": "Front left view",
    "capture_thumbnail": "Capture thumbnail",
    "preview_info_heading": "Check the preview and adjust the model if necessary ensuring:",
    "preview_info_model_appears": "The model appears in the preview as expected",
    "preview_info_centered": "The centre of the model intersects with the blue line",
    "preview_info_orientation": "The model is oriented correctly and faces fowards when viewing from the front",
    "model_not_supported_error": "Model is not supported, try a different file or contact support."
  },
  "modelShowThumbnailUploader": "or upload a file",
  "not_support_custom_colour": "The model you've upload doesn't support custom colours. To see how to enable this, view the article ",
  "areaModel": {
    "distribution": {
      "title": "Distribution",
      "random": "Random",
      "uniform": "Uniform"
    },
    "rotation": {
      "title": "Rotation",
      "random": "Random",
      "uniform": "Uniform"
    }
  },
  "systemDataFieldNames": {
    "MapObjectName": "Map Object Name",
    "MapObjectArea": "Area",
    "MapObjectLength": "Length",
    "Coordinates": "Co-ordinates",
    "RouteTime": "Route Time",
    "QuantityOfModelsOnLine": "Quantity",
    "QuantityOfModelsInArea": "Quantity",
    "RotationZOfModelsInArea": "Rotation",
    "IconRotation": "Rotation",
    "ModelAltitude": "Altitude"
  },
  "dateTimeFilter": {
    "newObjectFilteredTitle": "Map object filtered",
    "newObjectFilteredBody": "The newly created map object was filtered by the date and time filter"
  },
  "sitemapVersion": {
    "twoDimensional": "2D",
    "threeDimensional": "3D"
  },
  "shareMap": {
    "copyNotification": "Shared map link has been copied to your clipboard",
    "useDescription": "Shared links are designed for private use with specific individuals only.",
    "warning": "Public posting or mass distribution (e.g., on websites, social media, or mailing lists) is not permitted. To find out more about how to share plans publicly, please contact support@iventis.com.",
    "customSharedLinkDuration": {
      "description": "Set link duration:",
      "duration": {
        "ThreeDays": "3 days",
        "SevenDays": "7 days",
        "FourteenDays": "14 days",
        "ThirtyDays": "30 days"
      },
      "contactSupport": "If you need to provide access for more than 30 days, please contact support@iventis.com to discuss your requirements."
    }
  },
  "screenshot": {
    "take_screenshot": "Take screenshot",
    "screenshot": "Screenshot",
    "copiedToClipboardToast": {
      "title": "Screenshot copied to clipboard",
      "message": "You can now paste it into another application"
    },
    "downloadedImageToast": {
      "title": "Screenshot downloaded",
      "message": "You can find it in your downloads folder"
    },
    "errorToast": {
      "title": "Something went wrong",
      "message": "Could not take screenshot, please try again"
    }
  },
  "style": {
    "altitude": "Altitude"
  }
}